import { Box, BoxProps } from "@chakra-ui/react";
import { forwardRef } from "react";

export const Card = forwardRef<HTMLDivElement, BoxProps>(function Card(
  { children, ...rest },
  ref
) {
  return (
    <Box
      ref={ref}
      bg="white"
      borderRadius="12px"
      borderWidth="1px"
      borderColor="#e6e6e6"
      boxShadow="0 1px 2px rgba(15, 23, 42, 0.04)"
      {...rest}
    >
      {children}
    </Box>
  );
});
